module.exports = __webpack_public_path__ + "static/1-005-3d9641617f0c10df169c84e3622ae7dd.png";